export default {
  // Форматирование валюты
  toCurrency (n, curr, LanguageFormat = navigator.language) {
    if (n === '') {
      return ''
    }
    return new Intl.NumberFormat(LanguageFormat, {
      style: 'currency',
      currency: curr,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(n)
  },
  calcPrice (rate, value, taskRate) {
    let realRate = toNumber(taskRate) || rate
    return Math.ceil(value * realRate / 60)
  },
  calcPrice2 (rate, task) {
    if (task.guarantee) {
      return 0
    }

    let realRate = toNumber(task.rate) || rate,
      value = toNumber(task.value)

    let firstPrice = Math.ceil(value * realRate / 60)

    if (task.speed) {
      return firstPrice * 2
    }

    return firstPrice
  },
  toNumber (value) {
    return toNumber(value)
  },
}

function toNumber (value) {
  const num = Number(value)
  return isNaN(num) ? 0 : num
}
